import { AppState } from 'redux/reducers';

export const getFavorites = ({ favorites }: AppState) => favorites.favoritesList;
export const getFavoritesLength = ({ favorites }: AppState) => favorites.favoritesList.length;
export const getFavoriteById =
  (id?: string) =>
  ({ favorites }: AppState) =>
    id ? favorites.favoritesIds[id] : false;
export const getCollapsableSports = ({ favorites }: AppState) => favorites.collapsableSports;
